
import React from 'react';
import SnowflakeCanvas from './components/SnowflakeCanvas.tsx';
import Header from './components/Header.tsx';
import HeroSection from './components/HeroSection.tsx';
import StatsBlock from './components/StatsBlock.tsx';
import LootBox from './components/LootBox.tsx';

const App: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-black font-orbitron overflow-hidden">
      <SnowflakeCanvas />
      <div className="relative z-10 flex flex-col items-center w-full px-4 sm:px-6 lg:px-8">
        <Header />
        <main className="w-full max-w-5xl mx-auto flex flex-col items-center gap-16 md:gap-24 py-16">
          <HeroSection />
          <StatsBlock />
          <LootBox />
        </main>
        <footer className="w-full text-center py-8 text-gray-500 text-sm">
          <p>&copy; 2025. Happy Birthday, Grisha!</p>
        </footer>
      </div>
    </div>
  );
};

export default App;
